// Aviso que bloquea el cobro mientras haya líneas a medio liberar o a medio apartar.
import { AlertTriangle, RotateCw } from 'lucide-react';
import { Button } from '@/kit';
import type { ChargeableLines } from '../api/useChargeableLines';
import { INTEGRATION_ACTION_LABEL, LOST_COPY } from '../integrationErrors';

export function UnchargeableLinesNotice({
    lines,
    onReload,
    onFixLost,
}: {
    lines: ChargeableLines;
    onReload: () => void;
    /** Lleva a Accesorios a quitar o cambiar las piezas que Zentral se llevó. */
    onFixLost: () => void;
}) {
    if (!lines.blocked) return null;
    if (lines.lostCount > 0) {
        return (
            <div
                role="alert"
                className="flex items-start gap-3 rounded-lg border border-warning-soft-border bg-warning-soft p-3 text-warning"
            >
                <AlertTriangle className="mt-0.5 size-4 flex-none" aria-hidden />
                <div className="min-w-0 flex-1 text-[12px] leading-relaxed">{LOST_COPY.title}</div>
                <Button size="sm" variant="secondary" onClick={onFixLost}>
                    {INTEGRATION_ACTION_LABEL['build-sale']}
                </Button>
            </div>
        );
    }
    const releasing = lines.releasingCount > 0;
    return (
        <div
            role="alert"
            className="flex items-start gap-3 rounded-lg border border-warning-soft-border bg-warning-soft p-3 text-warning"
        >
            <AlertTriangle className="mt-0.5 size-4 flex-none" aria-hidden />
            <div className="min-w-0 flex-1 text-[12px] leading-relaxed">
                {releasing
                    ? 'Hay productos que quitaste y el inventario no ha confirmado que se liberaron. No puedes cobrar hasta liberarlos.'
                    : 'Hay un producto que todavía se está apartando. Recarga la venta; si sigue así, regresa a Producto y quítalo.'}
            </div>
            <Button
                size="sm"
                variant="secondary"
                isLoading={lines.retrying}
                leftIcon={<RotateCw className="size-3.5" aria-hidden />}
                onClick={() => {
                    if (releasing) void lines.retry();
                    else onReload();
                }}
            >
                {releasing ? 'Reintentar liberar' : 'Recargar'}
            </Button>
        </div>
    );
}
